import { h } from 'preact';

interface UrlPreviewCarouselChevronProps {
  direction: 'left' | 'right';
}

/**
 * Thin right-pointing chevron on a tight viewBox (no extra padding).
 * Flip `direction` to `left` for the previous control.
 * Stroke uses `currentColor` so parents can theme via CSS `color`.
 */
const UrlPreviewCarouselChevron = ({
  direction,
}: UrlPreviewCarouselChevronProps) => (
  <svg
    width="9"
    height="15"
    viewBox="0 0 6 10"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    style={direction === 'left' ? { transform: 'scaleX(-1)' } : undefined}
  >
    <path
      d="M1.25 1 L4.75 5 L1.25 9"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.18"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UrlPreviewCarouselChevron;
